<template>
  <NText
    variant="caption1"
    weight="medium"
    class="text-neutral-secondary-press block text-right pr-3 mb-2 mt-3"
  >
    {{ t('search.recentSearch') }}
  </NText>

  <SymbolSearchResultItem
    v-for="(symbol, index) of recentSearchSymbols"
    :key="`${symbol.isin}${index}`"
    :symbol="symbol"
    should-update-data
    show-close-icon
    @remove-recent-item="emit('removeRecentItem', symbol)"
    @handle-symbol-click="emit('handleSymbolClick', symbol)"
  />
</template>
<script setup lang="ts">
import { SymbolResult } from '@libs/api-reference';
import { useI18n } from 'vue-i18n';

import SymbolSearchResultItem from './SymbolSearchResultItem.vue';

type RecentSearchProps = {
  recentSearchSymbols: SymbolResult[];
};

type RecentSearchEmits = {
  (e: 'handleSymbolClick', symbol: SymbolResult): void;
  (e: 'removeRecentItem', symbol: SymbolResult): void;
};

defineProps<RecentSearchProps>();
const emit = defineEmits<RecentSearchEmits>();

const { t } = useI18n();
</script>
